<template>
  <div class="status-badge" :class="statusClass">
    {{
      TICKET_STATUS_LIST.find((item) => item.value === props?.status)?.label ??
      '--'
    }}
  </div>
  <div v-if="showRefund">
    <a @click="props.refundClick">退票</a>
  </div>
</template>

<script setup>
import { TICKET_STATUS_LIST } from '@/constants'
import { computed } from 'vue'
const props = defineProps({
  status: Number,
  showRefund: Boolean,
  refundClick: Function
})

const statusClass = computed(() => {
  if (props.status === 10) return 'status-success'
  if (props.status === 20) return 'status-pending'
  if (props.status === 39) return 'status-neutral'
  if (props.status === 30) return 'status-neutral'
  if (props.status === 11) return 'status-partial-refund'
  if (props.status === 38) return 'status-partial-mixed'
  if (props.status === 34) return 'status-partial-reschedule'
  if (props.status === 32 || props.status === 31) return 'status-rescheduled'
  if (props.status === 35 || props.status === 36 || props.status === 41) return 'status-refunding'
  if (props.status === 37 || props.status === 40 || props.status === 12) return 'status-refunded'
  return 'status-default'
})
</script>

<style lang="scss" scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 74px;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  border: 1px solid #dbe2ee;
  color: #475569;
  background: #f8fafc;
}

.status-success {
  color: #166534;
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.status-pending {
  color: #b45309;
  border-color: #fde68a;
  background: #fffbeb;
}

.status-neutral {
  color: #1d4ed8;
  border-color: #bfdbfe;
  background: #eff6ff;
}

.status-partial-refund {
  color: #b45309;
  border-color: #fde68a;
  background: #fffbeb;
}

.status-partial-reschedule {
  color: #c2410c;
  border-color: #fed7aa;
  background: #fff7ed;
}

.status-partial-mixed {
  color: #9a3412;
  border-color: #fdba74;
  background: #fff7ed;
}

.status-rescheduled {
  color: #9a3412;
  border-color: #fdba74;
  background: #ffedd5;
}

.status-refunding {
  color: #b45309;
  border-color: #fde68a;
  background: #fffbeb;
}

.status-refunded {
  color: #166534;
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.refund-action {
  margin-top: 6px;

  a {
    color: #1d4ed8;
    text-decoration: underline;
    text-underline-offset: 2px;
  }
}
</style>
